// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__TfzWG","sidebar__logo":"Sidebar_sidebar__logo__3P0yx","sidemenu":"Sidebar_sidemenu__2qY5h","sidemenu__icon":"Sidebar_sidemenu__icon__2vcWJ"};